import { render } from "./Chat.vue?vue&type=template&id=ebe3814a&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=ebe3814a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe3814a"],['__file',"resources/js/components/whatsapp-managment/includes/Chat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebe3814a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebe3814a', __exports__)) {
    console.log('reload')
    api.reload('ebe3814a', __exports__)
  }
  
  module.hot.accept("./Chat.vue?vue&type=template&id=ebe3814a&scoped=true", () => {
    console.log('re-render')
    api.rerender('ebe3814a', render)
  })

}


export default __exports__